import { Component, inject, Input, OnInit } from '@angular/core';
import { Step, Stream } from '../../interfaces/trackdata';
import { TrackService } from '../../service/track.service';
import { TrackFile } from '../../interfaces/responsedata.ts/trackfiles';
import { UserdataService } from '../../service/userdata.service';
import { MatDialog } from '@angular/material/dialog';
import { ResultPreviewComponent } from '../../home/user/stream-dashboard/result-preview/result-preview.component';
import { StepResult, TrackResult } from '../../interfaces/responsedata.ts/trackresults';
import { InternLandingPageComponent } from '../intern-landing-page/intern-landing-page.component';
import { FeedbackPinsDashboardComponent } from '../../home/user/stream-dashboard/detail-track-row/feedback-pins-dashboard/feedback-pins-dashboard.component';


interface ShowResultListObject {
  streamId: string;
  name: string;
  results: StepResult[];
}
interface FeedbackCardResultItem {
  agentName: string;
  pins: FeedbackCardResultPin[];
}
interface FeedbackCardResultPin {
  topic: string;
  content: string;
}

@Component({
  selector: 'app-show-results-list',
  standalone: false,
  templateUrl: './show-results-list.component.html',
  styleUrl: './show-results-list.component.scss'
})
export class ShowResultsListComponent implements OnInit {

  // Injections
  trackService = inject(TrackService);
  user = inject(UserdataService);
  dialog = inject(MatDialog);

  // Input / Output
  @Input() roundId: string = "";
  @Input() trackProcessData: any;

  // Objects
  results: TrackResult[] = []
  files: TrackFile[] = []

  // Variables
  negativTopMargin: number = 0;
  showObject: ShowResultListObject[] = []
  userId: string = "";
  showResultList: boolean = false;
  counter: number = 0;
  sortResultIsRunning: boolean = false;
  loading: boolean = false;



  ngOnInit(): void {
    this.showObject = [];
    this.counter = 0;
    this.trackService.trackFiles.subscribe(files => {
      this.files = files;
    });
    this.trackService.trackResults.subscribe(results => {
      this.results = results;
      if (this.results?.length != 0 && this.sortResultIsRunning === false) this.sortResults();
    });

    this.userId = this.user.getUserDataByKey("id")!;
  }

  async sortResults() {


    this.sortResultIsRunning = true;
    this.showObject = [];
    this.counter = 0;

    while (this.trackProcessData === undefined) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    console.log("Results", this.results);

    // Define the View-Order
    this.showObject.push({
      "streamId": "J1S-8At2nL",
      "name": "Qualify",
      results: []
    });
    this.showObject.push({
      "streamId": "4dXLpB4Ll",
      "name": "Validate",
      results: []
    });
    this.showObject.push({
      "streamId": "export_reports",
      "name": "Results",
      results: []
    });


    for await (let r of this.results) {
      let stream = this.trackProcessData.streams.find((s: Stream) => s.id === r.streamId);
      if (!stream && r.streamId !== "export_reports") continue;

      let streamName = stream ? stream.name : 'Reports';
      this.counter += r.stepResults.length;

      // Get Filedata if existst
      for await (let res of r.stepResults) {
        res.file = await this.files.find((file: any) => file.id === res.fileId);
      }

      this.showObject.find((obj: ShowResultListObject) => obj.streamId === r.streamId)?.results.push(...r.stepResults);

    }

    // Sort List by StreamOrder in trackData
    this.showObject.forEach(async (item: ShowResultListObject) => {
      let templateArray = this.trackProcessData.streams.find((stream: any) => stream.id === item.streamId)?.steps || [];
      item.results = await item.results.sort((a, b) => {
        const indexA = templateArray.findIndex((item: Step) => item.id === a.stepId);
        const indexB = templateArray.findIndex((item: Step) => item.id === b.stepId);
        return indexA - indexB;
      });
    });
    this.sortResultIsRunning = false;

  }

  toggleResultView() {
    if (this.showObject.length === 0) return;
    this.showResultList = !this.showResultList;
  }

  async downloadFile(item: any, streamId: string) {
    // console.log("ITEM", item);

    // Case for LandingPage Preview
    if (item.stepId === "landingPage") {
      let dia = await this.dialog.open(InternLandingPageComponent, {
        panelClass: "feed-back-card",
        data: { projectId: this.roundId }
      });
      return;
    }


    // Case for Feedback Card
    if (item.stepId === "k9G9Fv8w6") {
      let dia = await this.dialog.open(FeedbackPinsDashboardComponent, {
        panelClass: "feed-back-card",
        autoFocus: false,
        data: {
          "name": this.trackProcessData.name,
          "feedbackCardResult": item.result,
          "trackId": this.trackProcessData.trackId,
          "roundId": this.roundId,
          "streamId": streamId,
          "results": this.results,
          "stepId": item.stepId
        }
      });

      return;
    }

    console.log(item);

    // Default Case
    if (!item.result.name && item.name) {
      if (typeof item.result === 'string') {
        item.result = { name: item.name };
      } else {
        item.result.name = item.name;
      }
    }
    let dia = await this.dialog.open(
      ResultPreviewComponent,
      { data: item.result }
    );

    dia.afterClosed().subscribe(async (result: any) => {
      if (result?.type === "download-pdf") {
        let type = item.name.toLowerCase().replace(/\s+/g, '_');
        this.loading = true;
        let file = await this.trackService.createFileFromResultData(this.roundId, item.result.name, result.resultData, type, item.stepId, streamId);
        this.loading = false;
        if (file === false) return;

        item.file = {
          "id": file.id,
          "fileName": file.identifer,
          "fileSize": file.size,
          "dateCreated": new Date().getTime()
        };
        this.loading = true;
        this.trackService.downloadTrackResultFile(this.roundId, item.file.id, item.file.fileName)
        this.loading = false;
      }
    })

    return;
  }
  async deleteFile(item: any) {
    let i = confirm('Are you sure you want to delete this file? All combined Memory-Data will also deleted.');
    if (!i) return;

    if (item.file.userId !== this.userId && item.file.projectOwnerId !== this.userId) {
      console.log('Unauthorized attempt to delete file by user:', this.userId, item);
      return;
    }
    this.loading = true;
    await this.trackService.deleteFileFromTrackResult(item.file.roundId, item.fileId, item.file.fileName);
    this.loading = false;
    let streamId = ""
    for await (let stream of this.trackProcessData.streams) {
      for await (let step of stream.steps) {
        if (step.id === item.stepId) {
          streamId = stream.id
        }
      }
    }
    if (streamId !== "") {
      this.loading = true;
      await this.trackService.updateTrackProgress(item.file.roundId, streamId, item.stepId);
      this.loading = false;
    }
  }
}
